export const BASIC_PLAN = 'BASIC';
export const PROFESSIONAL_PLAN = 'PROFESSIONAL';
export const DEFAULT_CONTACT = '+918240794517';
export const EMAIL_ID = 'foundry@nowpurchase.com';